import { useQuery } from '@tanstack/react-query';
import { supabaseHarvest } from '@/lib/supabase';
import type { SeasonCompletenessLevelRow, SeasonCompletenessRow } from '@/types/harvest';

export function useSeasonCompleteness() {
  return useQuery({
    queryKey: ['season-completeness'],
    queryFn: async (): Promise<SeasonCompletenessRow[]> => {
      const { data, error } = await supabaseHarvest
        .from('v_season_completeness_latest')
        .select('*')
        .order('is_complete', { ascending: true })
        .order('completeness_pct', { ascending: true });
      if (error) throw error;
      return (data ?? []) as SeasonCompletenessRow[];
    },
  });
}

export function useSeasonCompletenessLevels() {
  return useQuery({
    queryKey: ['season-completeness-levels'],
    queryFn: async (): Promise<SeasonCompletenessLevelRow[]> => {
      const { data, error } = await supabaseHarvest
        .from('v_season_completeness_latest_levels')
        .select('*')
        .eq('is_complete', false)
        .order('provider', { ascending: true })
        .order('sport_key', { ascending: true })
        .order('season_key', { ascending: true })
        .order('level_order', { ascending: true });
      if (error) throw error;
      return (data ?? []) as SeasonCompletenessLevelRow[];
    },
  });
}
